import React from 'react';

interface Props {
  className?: string;
}

export const PartyLogo: React.FC<Props> = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.395 16.02c-.47.083-.867.4-1.051.841L.117 51.04A1.4 1.4 0 0 0 1.38 53l.56-.14 34.2-14.218a1.4 1.4 0 0 0 .421-2.31L16.657 16.44a1.402 1.402 0 0 0-1.262-.42ZM10.63 33.11l2.312-5.533 12.475 12.466-5.537 2.312-9.25-9.245Zm.91 12.746 5.537-2.31-7.639-7.635-2.313 5.533 4.415 4.412Zm-5.536-1.61 2.803 2.8-4.765 1.962 1.962-4.763Zm22.216-5.393 4.906-2.031-16.96-16.95-2.032 4.903L28.22 38.853Z"
        fill="#000"
      />
      <path
        d="M21 19.42 22.646 21a10.879 10.879 0 0 0 3.057-5.359A10.679 10.679 0 0 0 25.527 10l-2.234.677a8.51 8.51 0 0 1 .118 4.456A8.643 8.643 0 0 1 21 19.421Z"
        fill="#000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m21.689 10-.845-2.832L18 6.372l2.044-2.124-.71-2.876 2.888.663L24.356 0l.8 2.832 2.844.84-2.044 2.124.71 2.877-2.844-.708L21.69 10Zm1.055-5.983-.94-.214.213.94-.684.727.94.256.257.94.726-.683.94.214-.213-.94.684-.727-.94-.256-.257-.94-.726.683Z"
        fill="#000"
      />
      <path
        d="M37.359 27.297A10.879 10.879 0 0 0 32 30.354L33.58 32a8.643 8.643 0 0 1 4.287-2.41 8.51 8.51 0 0 1 4.456.117L43 27.473a10.679 10.679 0 0 0-5.641-.176Z"
        fill="#000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m48.96 24 .925 3.08 3.115.929-2.239 2.347.779 3.177-3.164-.782L46.04 35l-.925-3.129-3.115-.88 2.239-2.347-.779-3.177 3.164.782L48.96 24Zm-2.042 7.563.9-.847 1.163.265-.265-1.164.846-.899-1.163-.317-.317-1.163-.9.846-1.163-.265.265 1.164-.846.899 1.163.317.317 1.163ZM37.624 11.239 39.96 9l.925 3.115L44 13.04l-2.239 2.287.779 3.164-3.164-.73L37.04 20l-.925-3.115L33 15.96l2.239-2.336-.73-3.164 3.115.779Zm.294 5.323.9-.846 1.163.265-.265-1.164.846-.899-1.163-.317-.317-1.164-.9.847-1.163-.265.265 1.164-.846.899 1.163.317.317 1.164Z"
        fill="#000"
      />
      <path
        d="M27 24.384 33.384 18 35 19.616 28.616 26 27 24.384Z"
        fill="#000"
      />
      <circle cx="13.5" cy="10.5" r="1.5" fill="#1A1A1A" />
      <circle cx="32.5" cy="2.5" r="1.5" fill="#1A1A1A" />
      <circle cx="37.5" cy="24.5" r="1.5" fill="#1A1A1A" />
      <circle cx="51.5" cy="19.5" r="1.5" fill="#1A1A1A" />
      <circle cx="44.5" cy="39.5" r="1.5" fill="#1A1A1A" />
    </svg>
  );
};
